import FlexTableItem from './FlexTableItem';

export default FlexTableItem;
